export default "__VITE_ASSET__a4d92b14__"